import { Outlet } from "react-router-dom";

function AdminSeasonManagePage() {
  return <Outlet />;
}

export default AdminSeasonManagePage;
